module.exports = "<div class=\"ml-3\">\n  <button class=\"btn btn-danger\" (click)=\"openConfirmationDialogue()\">\n    Delete\n  </button>\n</div>\n"